if (typeof Swiper !== 'undefined') {
  document.addEventListener('DOMContentLoaded', function() {
    const swipers = document.querySelectorAll('.smarte-collection-cirlces .swiper');
    swipers.forEach(function(swiperEl) {
      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: true,
        navigation: {
          nextEl: '.swiper-smarte-button-next',
          prevEl: '.swiper-smarte-button-prev',
        },
        breakpoints: {
          368: {
            slidesPerView: 2.4,
          },
                    1024: {
            slidesPerView: '6',
          },
          1424: {
            slidesPerView: '8',
          }
        }
      });
    });
  });
}